import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import { useLocation } from "react-router-dom"; //for relocating navbar

import Navbar from "./components/navBar";
import Alerts from "./components/Alerts/Alerts";

import { validateToken } from "./helpers/api";

const useStyles = makeStyles((theme) => ({
  switchStyles: {
    overflow: "auto",
  },
  loadingSpinner: {
    marginTop: "5%",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const Search = lazy(() => import("./scenes/search"));
const Space = lazy(() => import("./scenes/space"));
const ReferenceManager = lazy(() => import("./scenes/references"));
const Notebook = lazy(() => import("./scenes/notebook"));

function App() {
  const classes = useStyles();
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = unknown yet
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    async function checkAuth() {
      const valid = await validateToken();
      setIsAuthenticated(valid);
      setAuthLoading(false);
    }

    checkAuth();
  }, []);

  if (authLoading) {
    return (
      <CircularProgress
        className={classes.loadingSpinner}
        size={80}
        thickness={3}
      />
    );
  }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ContentWithConditionalNavbar
          isAuthenticated={isAuthenticated}
          classes={classes}
        />
        {/* <Navbar />  */}
      </BrowserRouter>
    </Provider>
  );
}
// New component to access useLocation inside Router
function ContentWithConditionalNavbar({ isAuthenticated, classes }) {
  const location = useLocation();
  const pathsToShowNavbar = [
    "/search",
    "/projects",
    "/references",
    "/notebook",
  ];
  const shouldShowNavbar = pathsToShowNavbar.includes(location.pathname);

  return (
    <>
      {shouldShowNavbar && <Navbar />}
      <Alerts />
      <Suspense
        fallback={
          <CircularProgress
            className={classes.loadingSpinner}
            size={80}
            thickness={3}
          />
        }
      >
        <Switch className={classes.switchStyles}>
          <Redirect from="/" to="/search" exact />
          <Route
            exact
            path="/login"
            render={() => {
              window.location.href = "/login";
            }}
          />
          <Route
            exact
            path="/register"
            render={() => {
              window.location.href = "/register";
            }}
          />
          <Route
            exact
            path="/forgot"
            render={() => {
              window.location.href = "/forgot";
            }}
          />
          <Route
            exact
            path="/reset"
            render={() => {
              window.location.href = "/reset";
            }}
          />
          <PrivateRoute
            path="/search"
            component={Search}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/projects"
            component={Space}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/references"
            component={ReferenceManager}
            isAuthenticated={isAuthenticated}
          />
          <PrivateRoute
            path="/notebook"
            component={Notebook}
            isAuthenticated={isAuthenticated}
          />
        </Switch>
      </Suspense>
    </>
  );
}

function PrivateRoute({ component: Component, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default App;
